import ServiceCTIRoute from "../../UrlRoute/ServiceCTI";

export const CREATE_CTI_CREDENTIAL = "CREATE_CTI_CREDENTIAL";
export const GET_ALL_CTI_CREDENTIAL = "GET_ALL_CTI_CREDENTIAL";
export const UPDATE_ALL_CTI_CREDENTIAL = "UPDATE_ALL_CTI_CREDENTIAL";
export const DELETE_CTI_CREDENTIAL = "DELETE_CTI_CREDENTIAL";
export const GET_CTI_TICKET_FIELD = "GET_CTI_TICKET_FIELD";
export const CREATE_CTI_TICKET = "CREATE_CTI_TICKET";
export const SAVE_TICKET_FIELD = "SAVE_TICKET_FIELD";
export const GET_CTI_LOG = "GET_CTI_LOG";

// ==================================== Create CTI Credential ======================================//
export const CreateCtiCredential = (data, type) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.CreateCtiCredential(data, type)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: CREATE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: CREATE_CTI_CREDENTIAL,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: CREATE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: CREATE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Create CTI Credential ======================================//
// ==================================== Get All CTI Credential ======================================//
export const GetAllCtiCredential = (param, type) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.GetAllCtiCredential(param, type)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: GET_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: GET_ALL_CTI_CREDENTIAL,
            payload: {
              data: response.data,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: GET_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: GET_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Create CTI Credential ======================================//
// ==================================== Update CTI Credential ======================================//
export const UpdateCtiCredential = (data, type, ctiId) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.UpdateCtiCredential(data, type, ctiId)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: UPDATE_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: UPDATE_ALL_CTI_CREDENTIAL,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: UPDATE_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: UPDATE_ALL_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== Update CTI Credential ======================================//
// ==================================== Delete CTI Credential ======================================//
export const DeleteCtiCredential = (type, ctiId) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.DeleteCtiCredential(type, ctiId)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: DELETE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: DELETE_CTI_CREDENTIAL,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: DELETE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: DELETE_CTI_CREDENTIAL,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Delete CTI Credential ======================================//

// ==================================== Start Get CTI Ticket Field ======================================//
export const GetCtiTicketField = (type, orgUuid) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.GetTicketField(type, orgUuid)
      .then((response) => {
        // console.log(response, "response GET CTI DATA @");
        if (response.data.length === 0) {
          dispatch({
            type: GET_CTI_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: GET_CTI_TICKET_FIELD,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: GET_CTI_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: GET_CTI_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Get CTI Ticket Field ======================================//
// ==================================== CTI Create Ticket ======================================//
export const CreateCtiTicket = (type, data) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.CreateCtiTicket(type, data)
      .then((response) => {
        // console.log(response, "response CREATE TICKET CTI");
        if (response.data.length === 0) {
          dispatch({
            type: CREATE_CTI_TICKET,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: CREATE_CTI_TICKET,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        // console.log(error, "ERROR CREATING CTI TICKET");
        if (error.response && error.response.data) {
          dispatch({
            type: CREATE_CTI_TICKET,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: CREATE_CTI_TICKET,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== CTI Create Ticket ======================================//
// ==================================== CTI Save Ticket Field======================================//
export const SaveTicketField = (type, data) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.SaveTicketField(type, data)
      .then((response) => {
        console.log(response, "response SAVE TICKET FIELD CTI");
        if (response.data.length === 0) {
          dispatch({
            type: SAVE_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: SAVE_TICKET_FIELD,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error, "ERROR CREATING CTI TICKET");
        if (error.response && error.response.data) {
          dispatch({
            type: SAVE_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: SAVE_TICKET_FIELD,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== CTI Save Ticket Field======================================//
// ==================================== GET CTI LOG ======================================//
export const GetCtiLog = (param) => {
  return async (dispatch) => {
    return await ServiceCTIRoute.GetCtiLog(param)
      .then((response) => {
        // console.log(response, "response GET CTI LOG");
        if (response.data.length === 0) {
          dispatch({
            type: GET_CTI_LOG,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: GET_CTI_LOG,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error, "ERROR GET CTI LOG");
        if (error.response && error.response.data) {
          dispatch({
            type: GET_CTI_LOG,
            payload: {
              data: false,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: GET_CTI_LOG,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== GET CTI LOG ======================================//
